import React, { useMemo } from "react";
import { Layer, Rect } from "react-konva";

import { ISelection } from "../StateManager/state";
import { Offset, Scale } from "./types";

interface IProps {
  readonly offset: Offset;
  readonly scale: Scale;
  readonly selection: ISelection | null;
}

interface ISelectionBoxProps {
  readonly offset: Offset;
  readonly scale: Scale;
  readonly selection: ISelection;
}

const computeSelectionCorners = (selection: ISelection): [number, number, number, number] => [
  Math.min(selection.startx, selection.endx),
  Math.min(selection.starty, selection.endy),
  Math.max(selection.startx, selection.endx),
  Math.max(selection.starty, selection.endy),
];

const SelectionBox = ({ selection, offset, scale }: ISelectionBoxProps) => {
  const [minX, minY, maxX, maxY] = useMemo(() => computeSelectionCorners(selection), [selection]);
  return (
    <Rect
      height={(maxY - minY) * scale.y}
      fill="#000000"
      opacity={0.15}
      width={(maxX - minX) * scale.x}
      x={minX * scale.x + offset.x}
      y={minY * scale.y + offset.y}
    />
  );
};

export const Selection = ({ selection, ...remaining }: IProps) => {
  if (!selection) {
    return <Layer />;
  }
  return (
    <Layer>
      <SelectionBox selection={selection} {...remaining} />
    </Layer>
  );
};
